module.exports = __webpack_public_path__ + "static/media/logo_bxl.572d252b.png";